import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=63898be7&scoped=true&lang=pug"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"
import style0 from "./loading.vue?vue&type=style&index=0&id=63898be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63898be7",
  null
  
)

export default component.exports